import { FC } from 'react'
import Skeleton from '@components/skeleton'
import {
    CellContent,
    FilterButton,
    Search,
    SearchFilterSection,
    SkeletonContent,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
    TableSection,
    Title,
    TitleSection,
} from '@components/skeleton-table/skeletonTable.styles'
import { AssetsSkeletonProps } from './AssetsSkeleton.types'

const ROW_COUNT = 8
const DEFAULT_COLUMN_COUNT = 4

const AssetsSkeleton: FC<AssetsSkeletonProps> = ({
    columnCount = DEFAULT_COLUMN_COUNT,
}) => {
    const columns = Array.from({ length: columnCount })
    const rows = Array.from({ length: ROW_COUNT })

    return (
        <Skeleton>
            <SkeletonContent>
                <TitleSection>
                    <Title />
                </TitleSection>
                <SearchFilterSection>
                    <Search />
                    <FilterButton />
                </SearchFilterSection>
                <TableSection>
                    <TableHeader data-testid="assets-skeleton-header">
                        {columns.map((_, index) => (
                            <TableHeaderCell
                                key={index}
                                data-testid="assets-skeleton-header-cell"
                            />
                        ))}
                    </TableHeader>
                    {rows.map((_, rowIndex) => (
                        <TableRow
                            key={rowIndex}
                            data-testid="assets-skeleton-row"
                        >
                            {columns.map((__, cellIndex) => (
                                <TableCell
                                    key={cellIndex}
                                    data-testid="assets-skeleton-cell"
                                >
                                    <CellContent />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableSection>
            </SkeletonContent>
        </Skeleton>
    )
}

export default AssetsSkeleton
